import { Component, OnInit, Input } from '@angular/core';
import { UtilService } from './../../../../shared/services/util/util.service';


@Component({
  selector: 'app-placeholder-loader',
  templateUrl: './placeholder-loader.component.html',
  styleUrls: ['./placeholder-loader.component.scss']
})
export class PlaceholderLoaderComponent implements OnInit {
  @Input() public type = 'fundraiser';
  @Input() public count = 1;
  loaderCount: any[] = [];
  isMobile: any;

  constructor(
    private utilService: UtilService

  ) { }
  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
    let i = this.count;
    while (i >= 1) {
      this.loaderCount.push('');
      i--;
    }
  }

  setTop(i) {
    return i === 1 ? '0px' : i + 48 + 'px';
  }

}
